import React, { useState } from 'react';
import '../assets/scss/textareaComponent.scss';

const TextareaComponent = ({
	label,
	name,
	className,
	placeholder,
	required,
	register,
	cols,
	rows,
	counter,
	maxLength,
	...rest
}) => {
	const [charactersTyped, setCharactersTyped] = useState(0);
	const limit =
		maxLength != null && maxLength !== ''
			? Number(maxLength)
			: counter
				? 120
				: undefined;
	const { onChange: restOnChange, ...restProps } = rest;
	const registration = register(name, {
		required: required ? 'Påkrevd felt' : false,
		maxLength: limit
			? { value: limit, message: `Maks ${limit} tegn` }
			: undefined,
	});

	const handleInputChange = (event) => {
		setCharactersTyped(event.target.value.length);
		registration.onChange(event);
		if (typeof restOnChange === 'function') {
			restOnChange(event);
		}
	};

	return (
		<div
			className={`textarea-container ${className} ${
				counter ? 'with-counter' : ''
			}`}
		>
			<label htmlFor={name}>
				{label}
				{required && (
					<span style={{ color: 'red' }} className='required'>
						*
					</span>
				)}
			</label>
			<textarea
				name={name}
				id={name}
				cols={cols}
				rows={rows}
				required={required}
				placeholder={placeholder}
				{...registration}
				{...restProps}
				maxLength={limit}
				onInput={handleInputChange}
				onChange={handleInputChange}
			></textarea>
			{counter && (
				<div className='char-counter'>
					{charactersTyped} / {limit || 120}
				</div>
			)}
		</div>
	);
};

export default TextareaComponent;
